import { render, staticRenderFns } from "./PazienteEventiList.vue?vue&type=template&id=3c509c20"
import script from "./PazienteEventiList.vue?vue&type=script&lang=js"
export * from "./PazienteEventiList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports